import { combineReducers } from "@reduxjs/toolkit";
import common from "./commonSlice";
import message from "./messageSlice";

const reducer = combineReducers({
    common,
    message,
});

export default reducer;
